import axios from "axios";
import { getSessions, getSessionsByDate, getSessionsByProposal } from '../api/ispyb.js';
import { FETCH_SESSION, FETCH_SESSION_BY_DATE, FETCH_SESSION_BY_PROPOSAL } from '../constants/ActionTypes';

export function fetchSessions(user) {      
    return {
        type: FETCH_SESSION,
        payload: axios.get(getSessions(user))      
    };     
}

export function fetchSessionsByDate(user, startDate, endDate) {            
    return {
        type: FETCH_SESSION_BY_DATE,
        payload: axios.get(getSessionsByDate(user, startDate, endDate))      
    };     
}

export function fetchSessionsByProposal(user, startDate, endDate) {            
    return {
        type: FETCH_SESSION_BY_PROPOSAL,
        payload: axios.get(getSessionsByProposal(user, startDate, endDate))      
    };     
}





// WEBPACK FOOTER //
// ./src/actions/sessions.js